
import { Vue, Component, Watch } from "vue-property-decorator";
import MBA from "./components/mba.vue";
import EMBA from "./components/emba.vue";
import EMBAOnline from "./components/embaOnline.vue";
import BLM from "./components/blm.vue";
import PM from "./components/pm.vue";
import DYYJSH from "./components/dyyjsh.vue";
import { getInfo } from "@/apis/student";
import { Message } from "element-ui";
import { pinyin } from "pinyin-pro";

@Component({
  components: {
    MBA,
    EMBA,
    BLM,
    PM,
    EMBAOnline,
    DYYJSH
  }
})
export default class Layout extends Vue {
  tips = "请输入";
  form = {
    name: "",
    id: ""
  };
  info: any = {}; // 学籍信息
  mounted() {
    if (window.$getCookie("zh_choose") == "t") {
      this.tips = "請輸入";
    } else {
      this.tips = "请输入";
    }
  }
  // 查询信息过滤
  async search() {
    let nameErr = "请输入姓名";
    let idErr = "请输入证件号码";
    if (window.$getCookie("zh_choose") == "t") {
      nameErr = "請輸入姓名";
      idErr = "請輸入證件號碼";
    }
    if (!this.form.name.length) {
      Message.error(nameErr);
      return;
    }
    if (!this.form.id) {
      Message.error(idErr);
      return;
    }
    this.info = {};
    const data = await getInfo({
      q: `${window.$simplized(this.form.name)}_${this.form.id}`
    });
    this.info = data;
    if (this.info.mba) {
      let a = pinyin(this.info.mba.name, {
        toneType: "none",
        type: "array"
      }).join(" ");
      this.info.mba.pyname = a.toUpperCase();
    }
    if (this.info.emba) {
      let a = pinyin(this.info.emba.name, {
        toneType: "none",
        type: "array"
      }).join(" ");
      this.info.emba.pyname = a.toUpperCase();
    }

    if (this.info.blm) {
      let a = pinyin(this.info.blm.name, {
        toneType: "none",
        type: "array"
      }).join(" ");
      this.info.blm.pyname = a.toUpperCase();
    }
    if (this.info.pm) {
      let a = pinyin(this.info.pm.name, {
        toneType: "none",
        type: "array"
      }).join(" ");
      this.info.pm.pyname = a.toUpperCase();
    }

    if (this.info.dyyjsh) {
      let a = pinyin(this.info.dyyjsh.name, {
        toneType: "none",
        type: "array"
      }).join(" ");
      this.info.dyyjsh.pyname = a.toUpperCase();
    }

    if (this.info.jihe) {
      let a = pinyin(this.info.jihe.name, {
        toneType: "none",
        type: "array"
      }).join(" ");
      this.info.jihe.pyname = a.toUpperCase();
    }
    if (
      this.info.emba == null &&
      this.info.mba == null &&
      this.info.blm == null &&
      this.info.pm == null &&
      this.info.jihe == null &&
      this.info.dyyjsh == null
    ) {
      let nodata = "未查到任何信息，请检查输入是否正确";
      if (window.$getCookie("zh_choose") == "t") {
        nodata = "未查到任何信息，請檢查輸入是否正確";
      }
      Message.error(nodata);
    }
  }
}
